<template>
  <div class="card">
    <div v-for="(item,index) in homeData" :key="index" class="card-item">
      <div class="name">{{ item.label }}</div>
      <div class="center">
        <!-- <p v-for="val in item.children" :key="val.key"> -->
          <el-tag v-for="val in item.children" :key="val.key" v-show="useShow(item.key,val.key)" type="danger">{{ val.label }}</el-tag>
          <!-- <span class="label">{{ val.label }}</span>
          <span v-if="selectMonitorInfo" class="value">{{ selectMonitorInfo ? selectMonitorInfo[item.key][val.key] : '-' }}</span> -->
        <!-- </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import { homeData } from '@/assets/js/registerType.js';
export default {
  name:'CardInfo',
  props:{
    selectMonitorInfo:{
      type:Object,
      default:() => {}
    }
  },
  data(){
    return {
      homeData:homeData.filter(item => item.type === 'object')
    }
  },
  methods: {
    useShow(parentKey,key){
      if(this.selectMonitorInfo && this.selectMonitorInfo[parentKey]){
        return this.selectMonitorInfo[parentKey][key] === 1;
      }else{
        return false;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.card{
  display: flex;
  justify-content: space-between;
  margin: 14px 0;
  &-item{
    background: #F7F7F7;
    box-shadow: 0 0 5px #ccc;
    border-radius: 4px;
    width: calc(25% - 20px);
    .name{
      font-size: 18px;
      font-weight: 600;
      font-family: 'PingFang SC';
      color: #303030;
      padding: 16px 20px;
      border-bottom: 1px solid #ccc;
    }
    .center{
      height: 160px;
      overflow-y: auto;
      box-sizing: border-box;
      padding: 10px;
      @include scrollBar;
      .el-tag{
        margin-right: 10px;
        margin-bottom: 10px;
      }
      >p{
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .label{
          color: #909090;
        }
        .value{
          color: #000;
        }
      }
    }
  }
}
</style>
